import {
  DATASET_PROCESS_SUCCESS,
  DATASET_PROCESS_FAILURE,
  DATASET_DELETE_SUCCESS,
  DATASET_DELETE_FAILURE,
} from "./types";

// ---------------- DATASET PROCESS ----------------
export const datasetProcessSuccess = (project, recordings) => ({
  type: DATASET_PROCESS_SUCCESS,
  project,
  recordings,
});

export const datasetProcessFailure = (project) => ({
  type: DATASET_PROCESS_FAILURE,
  project,
});

export const datasetDeleteSuccess = (projectId) => ({
  type: DATASET_DELETE_SUCCESS,
  projectId,
});

export const datasetDeleteFailure = (projectId, error) => ({
  type: DATASET_DELETE_FAILURE,
  projectId,
  error,
});
